module.exports = "<div class=\"loader-overlay\" [hidden]=\"!show\"\n  [ngClass]=\"{\n    fixed: fixed\n  }\"\n>\n  <div class=\"spinner\"></div>\n</div>\n"